var _defs, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorker(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#000FFF;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M0,0H24V24H0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M20.84,4.22a2.211,2.211,0,0,0-.18-.34,1.982,1.982,0,0,0-.54-.54,2.211,2.211,0,0,0-.34-.18A2.013,2.013,0,0,0,19,3H18V1H16V3H8V1H6V3H5a2.028,2.028,0,0,0-1.12.34,1.982,1.982,0,0,0-.54.54,2.211,2.211,0,0,0-.18.34A2.013,2.013,0,0,0,3,5V19a2,2,0,0,0,2,2H19a2.013,2.013,0,0,0,.78-.16,2.211,2.211,0,0,0,.34-.18,1.982,1.982,0,0,0,.54-.54A2.053,2.053,0,0,0,21,19V5a2.013,2.013,0,0,0-.16-.78ZM5,19V5H19V19Zm7-6.12c-2.03,0-6,1.08-6,3.58V18H18V16.47c0-2.51-3.97-3.59-6-3.59ZM8.31,16A7.011,7.011,0,0,1,12,14.88,6.982,6.982,0,0,1,15.69,16ZM12,12A3,3,0,1,0,9,9,3.009,3.009,0,0,0,12,12Zm0-4a1,1,0,1,1-1,1A1,1,0,0,1,12,8Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorker);
export default __webpack_public_path__ + "static/media/worker.250a37ac54da2c7bee9603bd19e4200f.svg";
export { ForwardRef as ReactComponent };